import { Autocomplete, Box, Modal, Slide, Button, Typography } from "@mui/material"
import { CstmTextField } from "../../../../../../core/global/forms/CstmTextField"
import { Generate } from "./Generate"
import { ToolContext } from "../../../../../../core/context/ToolContext"
import { useContext } from "react"
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

import moment from "moment"
import { DataSetArray } from "./DataSetArray"
import Excel from "../../../../../../assets/images/icons/excel.png"
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;


export const Thead = ({ inputChangeHandler, open, setOpen }) => {

    const { report_state, setup_state, global_component_state } = useContext(ToolContext)
    const { form, salesBranchList } = report_state
    const { branchData, toolUser } = setup_state
    const { snackBarLoader } = global_component_state

    return (
        <>
            {/* TOP BUTTON */}
            <Box sx={{ width: "100%", display: "flex", gap: 2, mb: 2 }}>
                <Button onClick={() => setOpen(true)} fullWidth variant="contained" sx={{ borderRadius: 2, fontSize: 14, boxShadow: 0, py: 1, minHeight: "48px"}}>
                    Generate
                </Button>
                {salesBranchList.data.length > 0 && (
                    <ExcelFile filename={`Sales_Product_Reports_${moment(new Date()).format('MM/DD/YYYY')}`}
                        element={
                            <Box display="flex" alignItems="center" className="c-pointer" bgcolor="#d5ffe6ff" borderRadius={2} padding="12px 16px" minWidth="200px">
                                <img src={Excel} alt="excel-img" />
                                <Box ml="10px" color="#1D6F42"  fontSize={14}>Export in excel</Box>
                            </Box>
                        }
                    >
                        <ExcelSheet dataSet={DataSetArray(salesBranchList.data)} name="Reports" />
                    </ExcelFile>
                )}
            </Box>

            {/* MODAL */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Slide in={open} direction="up">
                    <Box
                        minHeight="170px"
                        display="flex"
                        flexDirection="column"
                        gap={1.5}
                        position="absolute"
                        bottom={0}
                        width="100%"
                    >
                        <Box
                            width="100%"
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            gap={3}
                            bgcolor="#FFFFFF"
                            sx={{ borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
                            px={2}
                            pt={4}
                            pb={2}
                        >
                            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                <Typography>Generate Branch Sales</Typography>
                                <CloseRoundedIcon onClick={() => setOpen(false)} />
                            </Box>

                            {/* BRANCH */}
                            <Box width="100%" id="walkthrough-branch-sales-report-step-1">
                                <Autocomplete
                                    fullWidth
                                    options={branchData.data}
                                    getOptionLabel={(option) => option.name || ""}
                                    onChange={(e, value) => inputChangeHandler(e, value, 'branch_id')}
                                    value={
                                        form.data.branch_id === ''
                                            ? null
                                            : branchData.data.find((f) => f.id === form.data.branch_id) || null
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option.name}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <CstmTextField {...params} label="Branch" placeholder="Branch" />
                                    )}
                                />
                            </Box>

                            {/* USER */}
                            <Box width="100%" id="walkthrough-branch-sales-report-step-2">
                                <Autocomplete
                                    fullWidth
                                    options={toolUser.data}
                                    getOptionLabel={(option) =>
                                        `${option.first_name} ${option.last_name}`
                                    }
                                    onChange={(e, value) => inputChangeHandler(e, value, 'user_id')}
                                    value={
                                        form.data.user_id === ''
                                            ? null
                                            : toolUser.data.find((f) => f.id === form.data.user_id) || null
                                    }
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            {option.first_name} {option.last_name}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <CstmTextField {...params} label="User" placeholder="User" />
                                    )}
                                />
                            </Box>

                            {/* DATE FROM */}
                            <CstmTextField
                                id="walkthrough-branch-sales-report-step-3"
                                fullWidth
                                type="date"
                                variant="outlined"
                                label="Date From"
                                name="from"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{ inputProps: { max: "9999-12-31" } }}
                                onInput={(e) => inputChangeHandler(e)}
                                value={form.data.from}
                                error={snackBarLoader.data && form.data.from === ''}
                            />

                            {/* DATE TO */}
                            <CstmTextField
                                id="walkthrough-branch-sales-report-step-4"
                                fullWidth
                                type="date"
                                variant="outlined"
                                label="Date To"
                                name="to"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputProps: {
                                        min: form.data.from,
                                        max: "9999-12-31"
                                    }
                                }}
                                onInput={(e) => inputChangeHandler(e)}
                                value={form.data.to}
                                error={
                                    (snackBarLoader.data && form.data.to === '') ||
                                    (form.data.to < form.data.from)
                                }
                            />
                            <Generate setOpen={setOpen}/>
                        </Box>
                    </Box>
                </Slide>
            </Modal>
        </>
    )
}